import * as m from "../../es2015/plugins/rangeSelector";
window.am4plugins_rangeSelector = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/rangeSelector.js
// module id = null
// module chunks = 